module.exports = "img/flags/IR.28848ac.png";